import UnsavedChangesDialog from "./UnsavedChangesDialog";
import { selectHasUnsavedWork } from "../features/appState/uxSlice";
import { store } from "../features/store";
import { useBlocker } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const UnsavedWorkGuard = () => {
  const hasUnsavedWork = useSelector(selectHasUnsavedWork);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation, historyAction }) =>
      // Back/forward restores old history state, so only trust the flag on a new navigation.
      !(historyAction !== "POP" && nextLocation.state?.unsavedWorkDiscarded) &&
      currentLocation.pathname !== nextLocation.pathname &&
      // Read the store live: useBlocker swaps in a new predicate only in an effect, after e.g. logout's redirect.
      selectHasUnsavedWork(store.getState())
  );

  useEffect(() => {
    if (!hasUnsavedWork) {
      return;
    }
    const handleBeforeUnload = (e: BeforeUnloadEvent) => e.preventDefault();
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedWork]);

  return (
    <UnsavedChangesDialog
      open={blocker.state === "blocked"}
      onClose={() => blocker.reset?.()}
      onDiscard={() => blocker.proceed?.()}
    />
  );
};

export default UnsavedWorkGuard;
